module.exports = __webpack_public_path__ + "icons/original/small/small-e4.967aa445a182fda8b3261d4612d3a3fc.png";


//////////////////
// WEBPACK FOOTER
// ./src/web/icons/original/small/small-e4.png
// module id = XnXw
// module chunks = app